export enum ResidenceStatus {
  OwnsResidence = "OWNS_A_RESIDENCE",
  DoesNotOwnResidence = "DOES_NOT_OWN_A_RESIDENCE",
  Unknown = "UNKNOWN",
}
